var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBall75 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 70 70",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        mask: url(#mask);\n      }\n\n      .st1 {\n        fill: #12cdff;\n      }\n\n      .st2 {\n        fill: url(#radial-gradient);\n      }\n\n      .st3 {\n        isolation: isolate;\n      }\n\n      .st4 {\n        mix-blend-mode: multiply;\n      }\n\n      .st5 {\n        fill: #fff;\n      }\n\n      .st6 {\n        fill: #082037;\n      }\n\n      .st7 {\n        fill: none;\n        stroke: #fff;\n        stroke-width: 2px;\n      }\n\n      .st8 {\n        fill: url(#radial-gradient1);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -368.8,
    cy: 628.8,
    fx: -368.8,
    fy: 628.8,
    r: 1,
    gradientTransform: "translate(-9783.3 28775.1) rotate(49.2) scale(41.7 -41.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1c1c1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -16.3,
    y: -16.9,
    width: 102.5,
    height: 97.5,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask0_51_25196"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 34.8,
    cy: 34.8,
    r: 34.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 34.8,
    cy: 34.8,
    r: 34.8
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient1",
    cx: -368.8,
    cy: 628.8,
    fx: -368.8,
    fy: 628.8,
    r: 1,
    gradientTransform: "translate(-9783.3 28775.1) rotate(49.2) scale(41.7 -41.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1c1c1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 34.8,
    cy: 34.8,
    r: 34.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M35-6l13.4,24.6,27.5,5.1-19.2,20.3,3.6,27.7-25.3-12-25.3,12,3.6-27.7L-5.9,23.7l27.5-5.1,13.4-24.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M50.9,14.4l.2.4h.5c0,0,32.7,6.2,32.7,6.2l-22.8,24.2-.3.3v.5c0,0,4.3,33,4.3,33l-30-14.3-.4-.2-.4.2-30,14.3,4.3-33v-.5c0,0-.3-.3-.3-.3L-14.3,21l32.7-6.1h.5c0,0,.2-.5.2-.5l15.9-29.2,15.9,29.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 34.8,
    cy: 34.8,
    r: 34.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 34.8,
    cy: 34.8,
    r: 34.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M34.4,24.4v4l-9.4,19.3h-6.9l9.4-18h0c0,0-10.4,0-10.4,0v-5.3h17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M51.8,29.6h-9.2l-.3,2.6c.5,0,.9,0,1.4,0,2.4,0,4.9.6,6.7,1.9,1.7,1.3,2.6,3.2,2.6,5.8,0,4.3-3.8,8.3-10.6,8.3s-5.4-.6-6.8-1.3l1.1-4.8c1.1.5,3.3,1.1,5.4,1.1s4.3-.7,4.3-2.9-1.9-3.3-6.5-3.3-2.1,0-3.1.2l1.5-12.7h13.6v5.3Z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBall75);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ball-75.bef615dc9cabba183000d7c71e3af7f1.svg";